import { render } from "./SlotWithEvolutionValue.vue?vue&type=template&id=8519cd58"
import script from "./SlotWithEvolutionValue.vue?vue&type=script&lang=js"
export * from "./SlotWithEvolutionValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__